export const PLATFORM_LABEL: Record<string, string> = { TWOGIS: '2ГИС', YANDEX: 'Яндекс' };

export const SENTIMENT_COLOR: Record<string, string> = {
  POSITIVE: 'var(--color-positive)',
  NEUTRAL: 'var(--color-neutral)',
  NEGATIVE: 'var(--color-negative)',
};

export const STATUS_LABEL: Record<string, string> = {
  NEW: 'Новый',
  NEEDS_REPLY: 'Нужен ответ',
  DRAFT_READY: 'Черновик готов',
  ANSWERED: 'Отвечен',
  SKIPPED: 'Пропущен',
};

export function ratingColor(rating: number): string {
  if (rating >= 4) return 'var(--color-positive)';
  if (rating === 3) return 'var(--color-neutral)';
  return 'var(--color-negative)';
}

const RELATIVE = new Intl.RelativeTimeFormat('ru', { numeric: 'auto' });

/** «сегодня», «3 дня назад», «12 марта» — компактно и по-человечески. */
export function relativeDate(value: Date | string): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  const diffMs = Date.now() - date.getTime();
  const diffDays = Math.floor(diffMs / 86_400_000);

  if (diffDays < 1) {
    const hours = Math.floor(diffMs / 3_600_000);
    if (hours < 1) return 'только что';
    return RELATIVE.format(-hours, 'hour');
  }
  if (diffDays < 7) return RELATIVE.format(-diffDays, 'day');
  return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' });
}

export const formatDate = (value: Date | string): string =>
  new Date(value).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', year: 'numeric' });

export const percent = (value: number): string => `${Math.round(value * 100)}%`;

export function signed(value: number, digits = 0): string {
  if (Math.abs(value) < (digits > 0 ? 10 ** -digits / 2 : 0.5)) return '—';
  return `${value > 0 ? '+' : '−'}${Math.abs(value).toFixed(digits)}`;
}

export function pluralize(count: number, one: string, few: string, many: string): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return `${count} ${one}`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${count} ${few}`;
  return `${count} ${many}`;
}

/**
 * Подпись под ответом: кто его написал и кто отправил на площадку.
 * Пустой publishedBy у опубликованного ответа означает автопубликацию —
 * это важно различать, поэтому так и пишем: «автоматически».
 */
export function replyAttribution(reply: {
  source: string;
  status: string;
  publishedBy: { name: string } | null;
  createdBy: { name: string } | null;
}): string {
  const written =
    reply.source === 'MANUAL'
      ? reply.createdBy
        ? `Написал ${reply.createdBy.name}`
        : 'Написано вручную'
      : reply.source === 'AI_EDITED'
        ? reply.createdBy
          ? `ИИ, правил ${reply.createdBy.name}`
          : 'ИИ, отредактировано'
        : 'Написал ИИ';

  if (reply.status !== 'PUBLISHED') return written;

  return reply.publishedBy
    ? `${written} · опубликовал ${reply.publishedBy.name}`
    : `${written} · опубликовано автоматически`;
}
